import React, { Fragment } from "react";

import { ElementState } from "@creatomate/preview";

import { IconName } from "@culturehq/components/dist/components/Icon";
import BarContent from "./BarContent";

interface ImageBarProps {
  currentElement: ElementState;
  iconClass: string;
  iconType: IconName;
}

const ImageBar: React.FC<ImageBarProps> = ({
  currentElement,
  iconClass,
  iconType
}) => (
  <Fragment>
    <BarContent
      currentElement={currentElement}
      iconClass={iconClass}
      iconType={iconType}
      isSmallElement={false}
    />
  </Fragment>
);

export default ImageBar;
